export default {
  // Título de la sección y acciones generales
  index: 'Permissions',
  ablePublish: 'Allow Publishing',
  geolocation: 'Activate/deactivate geolocation',

  // Permisos con subpermisos (acceso a módulo + alcance)
  franchises: 'Access to Business Units',
  locations: 'Access to Locations',
  roles: 'Access to Roles',
  users: 'Access to Users',
  forms: 'Access to Forms',
  catalogs: 'Access to Catalogs',
  routines: 'Access to routines',
  galleries: 'Access to Image Gallery',

  // Permisos simples (acceso a módulo)
  sprints: 'Access to Sprints',
  campaigns: 'Access to Campaigns',
  mailing: 'Access to Mailing',
  notifications: 'Access to Notifications Center',
  notices: 'Create Notices',
  'general-settings': 'Access to Configuration',

  // Permisos de formularios (roles especiales)
  'form-creator': 'Form Creator',
  'form-tester': 'Form Tester',
  'form-approver': 'Form Approver',

  // Otros permisos especiales
  'assign-exhibitions': 'Assign Exhibitions'
}
